"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.envConfigProvider = void 0;
function envConfigProvider() {
    function normalizeKey(key) {
        return key.replace(/\./g, '_');
    }
    return {
        load() {
            // noop
        },
        get(key) {
            return process.env[normalizeKey(key)];
        },
        getAll() {
            const envVars = Object.entries(process.env).filter(([, value]) => Boolean(value));
            return new Map(envVars);
        },
        has(key) {
            return normalizeKey(key) in process.env;
        },
    };
}
exports.envConfigProvider = envConfigProvider;
//# sourceMappingURL=env.js.map